/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useCallback, useRef } from 'react'
type AnyFn = (...args: any[]) => any
type FnOrNull = AnyFn | null
type ParamsOf<F extends FnOrNull> = F extends null ? never[] : Parameters<Extract<F, AnyFn>>
type UseDebounceResult<F extends FnOrNull> = F extends null ? null : (...args: ParamsOf<F>) => void
function useDebounce<F extends FnOrNull>(fn: F, delayMs = 200): UseDebounceResult<F> {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const result = useCallback(
    (...args: ParamsOf<F>): void => {
      if (!fn) return
      if (delayMs <= 0) return fn(...args)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        fn(...args)
        timeoutRef.current = null
      }, delayMs)
    },
    [fn, delayMs]
  )

  if (!fn) return null as UseDebounceResult<F>
  return result as UseDebounceResult<F>
}

export default useDebounce
